export default __webpack_public_path__ + "static/media/crece_background.cc1fdb5e.png";